











import { Component, Prop, Vue } from "vue-property-decorator";
import { Tile } from "@/types";

@Component
export default class TileComponent extends Vue {
  @Prop() private tile!: Tile;

  get display() {
    if (this.tile.flag) return "F";
    if (!this.tile.revealed) return " ";
    if (this.tile.type === "TYPE_BOMB") return "*";
    if (this.tile.type === "TYPE_NUMBER") return this.tile.value;
    return " ";
  }

  handleClick() {
    if (this.tile.flag) return;
    if (this.tile.revealed && this.tile.type === "TYPE_NUMBER") {
      this.$store.dispatch("revealAdjacent", this.tile);
    }
    this.$store.state.isPristine
      ? this.$store.dispatch("initialReveal", this.tile)
      : this.$store.dispatch("reveal", this.tile);
  }

  handleRightClick(e: Event) {
    e.preventDefault();
    if (this.tile.revealed) return;
    this.$store.dispatch("toggleFlag", this.tile);
  }
}
